import { render, staticRenderFns } from "./dashboard-created.vue?vue&type=template&id=51fe2568&"
import script from "./dashboard-created.vue?vue&type=script&lang=js&"
export * from "./dashboard-created.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports